import React, { useCallback, useState } from 'react';

import {
  Tabs,
  Tab,
  Divider,
  Box,
  Slide,
  Button,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import Goods from './Goods';

import entityTypes, { EntityTypes } from '../../../../../constants/entityTypes';
import GoodsForm from './forms';
import useDialogStatus from '../../../../../hooks/useDialogStatus';

const Create = () => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const [value, setValue] = useState<EntityTypes>(entityTypes.CAR);

  const handleChangeTab = useCallback((_event: React.SyntheticEvent, newValue: EntityTypes) => {
    setValue(newValue);
  }, []);

  return (
    <>
      <Slide direction="right" in={!open} appear={false}>
        <Box display={open ? 'none' : 'block'}>
          <Tabs value={value} onChange={handleChangeTab}>
            <Tab value={entityTypes.CAR} label="Cars" />
          </Tabs>
          <Divider />
          <Box marginTop={4}>
            {value === entityTypes.CAR && (
              <Goods
                type={entityTypes.CAR}
                handleOpenChange={openDialog}
              />
            )}
          </Box>
        </Box>
      </Slide>
      <Slide direction="left" in={open}>
        <Box display={!open ? 'none' : 'block'}>
          <Box marginBottom={4}>
            <Button startIcon={<ArrowBackIosNewIcon />} onClick={closeDialog}>
              Back
            </Button>
          </Box>
          <GoodsForm type={value} />
        </Box>
      </Slide>
    </>
  );
};

export default Create;
